


import { mobileCheck } from "./functions/mobile-check";
console.log(mobileCheck())


import { burger } from './functions/burger';

